var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.tests,
          columns: _vm.columns_tests,
          "row-key": "id",
          pagination: _vm.pagination_tests,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination_tests = $event
          },
          request: _vm.requestTests
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "title", attrs: { props: props } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(props.row.title) +
                          "\n                    "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "webcast_test_type", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                _vm.getTestType(props.row.webcast_test_type)
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_questions", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(props.row.qty_questions) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_user_results", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(props.row.qty_user_results) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatusTest(props.row.status),
                              color: _vm.getColorStatusTest(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getTextStatusTest(props.row.status)
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "actions",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "primary",
                              icon: "far fa-chart-line"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showTestDetails(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("average_results_tooltip")) +
                                  "\n                            "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "secondary",
                              icon: "far fa-users"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showTestUsers(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("participants_report_tooltip")
                                  ) +
                                  "\n                            "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_test_users,
            callback: function($$v) {
              _vm.show_test_users = $$v
            },
            expression: "show_test_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_test_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.test.title) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    ref: "table",
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.users,
                      columns: _vm.columns_users,
                      "row-key": "user_id",
                      pagination: _vm.pagination_users,
                      loading: _vm.loading,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination_users = $event
                      },
                      request: _vm.requestUserTests
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              staticClass: "q-mr-sm",
                              attrs: {
                                color: "secondary",
                                icon: "fas fa-download",
                                label: _vm.$t("test_report")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadReport()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                            "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return [
                            _c(
                              "q-tr",
                              {
                                staticClass: "cursor-pointer",
                                attrs: { props: props },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.showTestUsersResult(props.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-td",
                                  {
                                    key: "user_full_name",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(props.row.user_full_name) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "user_email",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(props.row.user_email) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "result_date",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.fDate(props.row.result_date)
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "time_to_answer",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.fTime(
                                            props.row.time_to_answer,
                                            "HH:mm:ss"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "percent", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          props.row.percent
                                            ? props.row.percent.toFixed() + "%"
                                            : ""
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "branches", attrs: { props: props } },
                                  [
                                    _c(
                                      "q-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          "text-color": "white",
                                          label: props.row.branches.length,
                                          "no-ripple": ""
                                        }
                                      },
                                      [
                                        _c("q-tooltip", [
                                          props.row.branches.length > 0
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass: "tooltip q-mb-sm"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t("branches")
                                                      ) +
                                                      ":\n                                                "
                                                  ),
                                                  _vm._l(
                                                    props.row.branches,
                                                    function(branche, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(branche) +
                                                              "\n                                                    "
                                                          ),
                                                          props.row.branches
                                                            .length -
                                                            1 >
                                                          index
                                                            ? _c("span", [
                                                                _vm._v(", ")
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "status",
                                    attrs: { props: props, "auto-width": "" }
                                  },
                                  [
                                    props.row.status
                                      ? _c(
                                          "q-chip",
                                          {
                                            staticClass:
                                              "full-width text-center",
                                            attrs: {
                                              small: "",
                                              icon: _vm.getIconStatusUser(
                                                props.row.status
                                              ),
                                              color: _vm.getColorStatusUser(
                                                props.row.status
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.getTextStatusUser(
                                                      props.row.status
                                                    )
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_test_users_result,
            callback: function($$v) {
              _vm.show_test_users_result = $$v
            },
            expression: "show_test_users_result"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_test_users_result = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.test.title) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  _vm._l(_vm.test_result, function(question, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "span",
                          { class: _vm.getQuestionClass(index, question) },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(index + 1) +
                                ") "
                            ),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(question.title) }
                            })
                          ]
                        ),
                        _c(
                          "q-field",
                          { attrs: { error: question.error } },
                          [
                            _c("q-option-group", {
                              staticClass: "questions q-mt-xs",
                              class: question.is_correct
                                ? "checkbox-hit"
                                : "checkbox-error",
                              attrs: {
                                type: "radio",
                                options: question.answers,
                                readonly: ""
                              },
                              on: {
                                input: function($event) {
                                  question.error = false
                                }
                              },
                              model: {
                                value: question.user_answer_id,
                                callback: function($$v) {
                                  _vm.$set(question, "user_answer_id", $$v)
                                },
                                expression: "question.user_answer_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_test_results,
            callback: function($$v) {
              _vm.show_test_results = $$v
            },
            expression: "show_test_results"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_test_results = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.test.title) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  [
                    _vm.permissions
                      ? _c("q-btn", {
                          staticClass: "q-mr-sm",
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-download",
                            label: _vm.$t("tests_report")
                          },
                          on: {
                            click: function($event) {
                              return _vm.downloadReportModel()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._l(_vm.test_results, function(question, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c(
                            "span",
                            { class: _vm.getQuestionClass(index, question) },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(index + 1) +
                                  ") "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(question.question)
                                }
                              })
                            ]
                          ),
                          _c(
                            "q-field",
                            { attrs: { error: question.error } },
                            [
                              _c("q-option-group", {
                                staticClass: "questions q-mt-xs",
                                attrs: {
                                  type: "radio",
                                  options: question.answers,
                                  readonly: ""
                                },
                                on: {
                                  input: function($event) {
                                    question.error = false
                                  }
                                },
                                model: {
                                  value: question.answer_correct_id,
                                  callback: function($$v) {
                                    _vm.$set(question, "answer_correct_id", $$v)
                                  },
                                  expression: "question.answer_correct_id"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }